import { FormattedRowParams } from '@qrios/frontend-library';

import creditTypesMapper from '../../../../constants/validation/creditTypesToString';

export const creditTypesFormatter = ({ value }: FormattedRowParams) => creditTypesMapper(value as string);
